<template>
    <a href="#" title="Dupliquer ce point" @click="duplicateItem()">
        <i class="far fa-fw fa-clone text-secondary"></i>
    </a>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../../dashboard/mixins/DataUpdater'

export default {
    name: 'DuplicatePendingPoint',

    mixins: [DataUpdater],

    props: {
        point: {},
    },

    methods: {
        async duplicateItem() {
            try {
                await axios.post(`/pendingPoints/${this.point.id}`)
                await this.updateData()
                await this.$store.dispatch(
                    'clientVM/getCounters',
                    this.point.client_id
                )
            } catch (error) {
                console.log(error)
            }
        },
    },

    computed: {
        ...mapState({
            pageName: (state) => state.browsing.pageName,
        }),
    },
}
</script>

<style scoped></style>
